import { Suspense } from 'react';
import { PageSkeleton } from '@/components/shared/ui/PageSkeleton';
import type { SkeletonType } from './types';

/**
 * Higher-order component that wraps lazy-loaded components with Suspense
 * and appropriate loading skeleton
 * 
 * @param Component - Lazy-loaded React component
 * @param skeletonType - Type of skeleton to show while loading
 * @returns Wrapped component with Suspense boundary
 * 
 * @example
 * const HomePage = withSuspense(lazy(() => import('./HomePage')), 'home');
 */
export const withSuspense = (
    Component: React.ComponentType,
    skeletonType: SkeletonType = 'default'
) => {
    return (props: any) => {
        return (
            <Suspense fallback={<PageSkeleton type={skeletonType} />}>
                <Component {...props} />
            </Suspense>
        );
    };
};
